'use client'
import React, { type LegacyRef } from 'react'

import { AbleTimeModel } from '@/components/purchase/components/parkinglot/model'
import PurchaseTimeNotice from '@/components/purchase/components/shared/purchaseTimeNotice/view'

import Button from '@/shared/components/button/Button'
import Icons from '@/shared/components/icon/Icons'
import { Caption, Text } from '@/shared/components/typography'

import { roboto } from '@/styles/font'

const PurchaseEnteringTime = ({
  onClickTimeValue,
  selectedIndex,
  time,
  onClickTimeNextBtn,
  handleNoticeOpen,
  contentHeight,
  isNoticeOpen,
  haveEnteringTime,
  footerRef
}: {
  time: AbleTimeModel[]
  selectedIndex: number | null
  onClickTimeValue: (i: number) => void
  onClickTimeNextBtn: () => void
  handleNoticeOpen: () => void
  contentHeight: number
  isNoticeOpen: boolean
  haveEnteringTime: boolean
  footerRef: LegacyRef<HTMLDivElement>
}) => {
  return (
    <>
      <div className={`flex flex-1 justify-center`} style={{ height: contentHeight, overflow: 'scroll' }}>
        <div className="flex flex-1 flex-col items-center bg-010 pt-4">
          <Text level="text1" color="text090" weight="bold">
            입차 예정 시간을 선택해 주세요.
          </Text>

          <div className={`${roboto.className} mt-10 flex w-full flex-col bg-010 text-center`}>
            {time.map((el, i) => (
              <div
                key={i}
                className={`cursor-pointer py-[20px] ${
                  selectedIndex === i && haveEnteringTime ? 'bg-main-010 font-medium' : ''
                }`}
                onClick={() => onClickTimeValue(i)}
              >
                <Text level="text2" color="text090">
                  {el.title}
                </Text>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={`sticky bottom-0 flex w-full flex-col gap-3 bg-010 px-4 py-3`}>
        <div className="rounded-md bg-020 px-3 py-3">
          <ol className="list-disc">
            <li className="list-style-desc">
              <Caption level="caption2" color="text070">
                당일 구매 및 사용만 가능합니다.
              </Caption>
            </li>
            <li className="list-style-desc">
              <Caption level="caption2" color="text070">
                입차 예정 시간에서 벗어나도{' '}
                <span className="text-caution-070">주차권 유효시간에 입차 시 이용 가능</span>합니다.
              </Caption>
            </li>
          </ol>
          <Caption level="caption2" color="text070" className="cursor-pointer">
            {
              <div onClick={handleNoticeOpen} className="ml-[9px] flex items-center gap-[2px]">
                <span className="underline">입차 예정 시간 안내</span>
                <Icons.LeftIcon stroke="currentColor" color="#6D7D90" />
              </div>
            }
          </Caption>
        </div>
        <div className="sticky bottom-0" ref={footerRef}>
          <Button
            text="다음"
            color="text010"
            background="bg030"
            onClick={onClickTimeNextBtn}
            disabled={!haveEnteringTime}
            className="body-1 h-[56px]"
            pyValue="py-0"
          />
        </div>
      </div>
      <PurchaseTimeNotice isOpen={isNoticeOpen} onClose={handleNoticeOpen} />
    </>
  )
}

export default PurchaseEnteringTime
